/// <reference path="formgroup.ts"/>

interface FormDescriptor
{
	action?: string;
	method?: string;
	tag?: string;
	orientation?: string;
	classes?: string[];
}

class Form
{
	protected element: JQuery;
	private btnList: JQuery;
	private btnListDiv: JQuery;
	private btnListAttached: boolean;
	private m_FormGroup: FormGroup[];

	constructor(descriptor: FormDescriptor)
	{
		this.btnListAttached	= false;
		this.btnList					= $( document.createElement( 'div' ) );
		this.btnListDiv				= $( document.createElement( 'div' ) );
		this.m_FormGroup			= [];

		this.btnList.addClass( 'form-group' );
		this.btnListDiv.addClass( 'col-xs-12' );
		this.btnList.append( this.btnListDiv );

		if ( descriptor.tag )
		{
			this.element = $( document.createElement( descriptor.tag ) );
		}
		else
		{
			this.element = $( document.createElement( 'form' ) ) as JQuery<HTMLElement>;

			if ( descriptor.method )
			{
				this.element.attr( 'method', descriptor.method );
			}
			else
			{
				this.element.attr( 'method', 'GET' );
			}

			if ( descriptor.action )
			{
				this.element.attr( 'action', descriptor.action );
			}
		}

		if ( descriptor.orientation )
		{
			this.element.addClass( 'form-' + descriptor.orientation );
		}

		if ( descriptor.classes )
		{
			for ( const i in descriptor.classes )
			{
				this.element.addClass( descriptor.classes[ i ] );
			}
		}
	}

	public Inputs(): BasicInputField[]
	{
		const l_Input: BasicInputField[] = [];

		for ( const i in this.m_FormGroup )
		{
			l_Input.push.apply( l_Input, this.m_FormGroup[ i ].Inputs() );
		}

		return l_Input;
	}

	public getElement() : HTMLElement
	{
		this.element.find( 'input' ).not( 'input[type="hidden"]' ).addClass( 'form-control' );
		this.element.find( 'select' ).addClass( 'form-control' );
		this.element.find( 'label' ).addClass( 'control-label' );

		if ( !this.btnListAttached )
		{
			this.btnListAttached = true;

			this.element.append( this.btnList );
		}

		return this.element[0];
	}

	public newFormGroup( width: number[] ) : FormGroup
	{
		const formgroup = new FormGroup( width, this.element.hasClass( 'form-horizontal' ), this.element.hasClass( 'form-inline' ) );

		this.m_FormGroup.push( formgroup );

		this.element.append(formgroup.getElement());

		return formgroup;
	}

	public addButton( btn: Button ) : void
	{
		this.btnListDiv.append( btn.getElement() );
	}

	public clearButtons() : void
	{
		this.btnListDiv.empty();
	}

}
